<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <select type="text" @change="updateValue($event.target.value)" :name="name" :required="required" class="form-control">
      <template v-if="banks">
        <option v-if="placeholder" value="">{{ placeholder }}</option>
        <option v-for="bank in banks" :value="bank.id" :selected="value == bank.id">{{ bank.bank_code }} - {{ bank.name }}</option>
      </template>
      <option v-else="" value="">Carregando bancos...</option>
    </select>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputBanks',
    props: ['name', 'value', 'required', 'label', 'placeholder', 'error'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    },
    asyncComputed: {
      banks: {
        get () {
          return this.$http.get('banks')
            .then(response => response.data.data, () => [])
        },
        default: false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputBanks.vue?fe9011a6